import { useSyncExternalStore } from 'react'
import { CollectionState } from '../collection-state'

export function useSelectedCell (state: CollectionState) {
  return useSyncExternalStore(
    callback => state.addEventListener('selectedCellChanged', callback),
    () => state.selectedCell
  )
}
